import { render, staticRenderFns } from "./ams.vue?vue&type=template&id=49be6e90&scoped=true"
import script from "./ams.vue?vue&type=script&lang=js"
export * from "./ams.vue?vue&type=script&lang=js"
import style0 from "./ams.vue?vue&type=style&index=0&id=49be6e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be6e90",
  null
  
)

export default component.exports